import axios from 'axios';
import { Notify } from 'quasar';
import type { RequestInterface } from '../types';
import { useUserStore } from '~/authentication/stores/user';

class ApiClient {
  public baseUrl: string;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
  }

  public async request(options: RequestInterface, config = {}): Promise<any> {
    const { method, path, data, headers, params } = options;
		console.log('baseUrl ', this.baseUrl);
		console.log('path', path);
    return axios({
      method,
      url: `${this.baseUrl}${path}`,
      ...(!!data && { data }),
      headers: { ...headers },
      params: { ...params },
      ...config,
    })
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch(async (error) => {
        return this.handleRequestError(error);
      });
  }

  public async autoLogin(token: string): Promise<any> {
    return this.request({
      method: 'POST',
      path: '/api/v1/auto-login',
      data: { token },
    });
  }

  protected async handleRequestError(error: any) {
    // Check if the error has a proper response structure (from Axios)
    // In tests, the error might not have the expected structure
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          this.redirectToLogin();
          return Promise.reject(error);
        case 403:
          this.notifyUnauthorized();
          return Promise.reject(error);
        case 404:
          this.notifyNotFound(error);
          return Promise.reject(error);
        case 422:
          this.notifyValidationError(error);
          return Promise.reject(error);
        case 500:
          this.notifyError();
          return Promise.reject(error);
        default:
          return Promise.reject(error);
      }
    }
    
    // If error doesn't have a response structure (e.g., in tests),
    // just reject with the original error
    return Promise.reject(error);
  }

  public notifyError() {
    Notify.create({
      message:
        'Something unexpected happen, please refresh the page and try again.',
      type: 'negative',
    });
  }

  public notifyValidationError(error: any) {
    const message = error.response?.data?.message || 'Validation error occurred';
    Notify.create({
      message,
      type: 'negative',
    });
  }

  public notifyUnauthorized() {
    Notify.create({
      message:
        'Access to this resource is forbidden. If you believe you should have access, please try logging out and back in again or contact the site administrator',
      type: 'negative',
    });
  }

  public redirectToLogin() {
    const userStore = useUserStore();
    userStore.unauthenticate();

    if (window.location.pathname !== '/login') {
      window.location.replace('/login');
    }
  }

  public notifyNotFound(error: any) {
    const message =
      error.response?.data?.message ||
      'The resource you are looking for cannot be found.';
    Notify.create({
      message,
      type: 'negative',
    });
  }
}
export default ApiClient;
